import type { Components } from '@mui/material/styles';

import type { Theme } from '../types';

export const MuiPaper = {
  styleOverrides: {
    root: {
      backgroundImage: 'none',
      borderRadius: '12px',
    },
  },
} satisfies Components<Theme>['MuiPaper'];
